$(function(){
    $('#root').css('zoom','normal')
    let scale = document.body.clientWidth / 1080;
    $('#root').css('zoom',scale)

    window.addEventListener('resize',function(){
        var timer;
        return function(){
            if(timer) clearTimeout(timer);
            timer = setTimeout(function(){
            $('#root').css('zoom','normal')
            let scale = document.body.clientWidth / 1080;
            $('#root').css('zoom',scale)
            },100)
        }
    }())

    window.onload = function () {
    const targetElement = document.getElementById('buyBox');
    const offsetTop = targetElement.offsetTop ;
	$('.buy').click(function(){
		window.scroll({
            top: offsetTop * ($('div#root').css('zoom')) - 140,
            behavior: 'smooth' // 使用 smooth 实现平滑滚动
        });
	})         
};
})